import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Chip, Typography } from "@mui/material";

const DEFAULT_VISIBLE_COUNT = 1;

const PermissionSummary = ({
  permissions,
  groups,
  visibleCount = DEFAULT_VISIBLE_COUNT,
}) => {
  const [expanded, setExpanded] = useState(false);

  const cleanPermissions = (items) =>
    items
      .map((permission) => String(permission ?? "").trim())
      .filter(Boolean);
  const permissionGroups = (groups.length
    ? groups.map((group) => ({
        ...group,
        permissions: cleanPermissions(group.permissions),
      }))
    : [{ moduleName: "Permissions", permissions: cleanPermissions(permissions) }]
  ).filter((group) => group.permissions.length);

  if (!permissionGroups.some((group) => group.permissions.length)) {
    return null;
  }

  const firstGroup = permissionGroups[0];
  const displayedGroups = expanded
    ? permissionGroups
    : [
        {
          ...firstGroup,
          permissions: firstGroup.permissions.slice(0, visibleCount),
        },
      ];
  const hasMore =
    permissionGroups.length > 1 || firstGroup.permissions.length > visibleCount;

  return (
    <Box className="audit-permissions">
      <Box className="audit-permissions__items">
        {displayedGroups.map((group) => (
          <Box className="audit-permissions__module" key={group.moduleName}>
            <Typography className="audit-permissions__module-name" component="span">
              {group.moduleName}
            </Typography>
            <Box className="audit-permissions__module-items">
              {group.permissions.map((permission, index) => (
                <Chip
                  key={`${group.moduleName}-${permission}-${index}`}
                  label={permission}
                  size="small"
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
      {hasMore && (
        <Button
          className="audit-permissions__toggle summary-more-button"
          size="small"
          onClick={() => setExpanded((currentValue) => !currentValue)}
          aria-expanded={expanded}
        >
          {expanded ? "Less" : "... More"}
        </Button>
      )}
    </Box>
  );
};

PermissionSummary.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  groups: PropTypes.arrayOf(PropTypes.shape({
    moduleName: PropTypes.string.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  visibleCount: PropTypes.number,
};

PermissionSummary.defaultProps = {
  permissions: [],
  groups: [],
  visibleCount: DEFAULT_VISIBLE_COUNT,
};

export default PermissionSummary;
